module.exports = new __parcel__URL__("jira-board.b6e126ca.svg").toString();